import { render, staticRenderFns } from "./ClinicCartDropDown.vue?vue&type=template&id=5348ba20&"
import script from "./ClinicCartDropDown.vue?vue&type=script&lang=js&"
export * from "./ClinicCartDropDown.vue?vue&type=script&lang=js&"
import style0 from "./ClinicCartDropDown.vue?vue&type=style&index=0&id=5348ba20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports